import React from 'react'
import { connect } from 'react-redux'

function homeImg (props = {}) {
  return <div className='home-img-container'>
    <a href='https://github.com/darrelltzj' target='_blank' rel='noopener noreferrer' className='links'>
      <img src='https://s3-ap-southeast-1.amazonaws.com/darrelltzjportfolio/images/darrelltzjProfile.jpg' alt='Darrell' style={{ width: '100%' }} />
    </a>
  </div>
}

function mapStateToProps (state = {}) {
  // const { navbar } = state
  return {}
}

export default connect(mapStateToProps)(homeImg)



// WEBPACK FOOTER //
// ./src/components/home/HomeImg.js